module.exports = __webpack_public_path__ + "img/img02.23c836d0.png";